import { EventsResponseModel } from '@swagger-sse/api';

import { LiveDataEvent } from '@store/types';
import { UnusableEvent, WallboxEvent, HeatPumpEvent } from '@store/actions';
import { GatewayEvent } from './events/gateway';

export class EventsFactory {
    public getEvent(eventData: EventsResponseModel | undefined): LiveDataEvent {
        if (!eventData) {
            return new UnusableEvent();
        }

        switch (eventData.deviceType) {
            case 'EV':
                return new WallboxEvent(eventData);
            case 'HEAT_PUMP':
                return new HeatPumpEvent(eventData);
            case 'Gateway':
                return new GatewayEvent(eventData);
            default:
                return new UnusableEvent();
        }
    }
}
